import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createCategory: [],
    loading: false,
    error: null,
};

const createCategorySlice = createSlice({
    name: "createCategory",
    initialState,
    reducers: {
        fetchCreateCategoryRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchCreateCategorySuccess: (state, action) => {
            state.loading = false;
            state.createCategory = action.payload;
        },
        fetchCreateCategoryFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchCreateCategoryRequest,
    fetchCreateCategorySuccess,
    fetchCreateCategoryFailure,
} = createCategorySlice.actions;

export default createCategorySlice.reducer;